import { supabase } from '../supabase';

export async function listMatches() {
  const { data, error } = await supabase
    .from('matches')
    .select('*, match_participants(user_id)')
    .order('match_date', { ascending: true });
  if (error) throw error;
  return (data || []).map(match => ({
    ...match,
    members: (match.match_participants || []).map(participant => participant.user_id),
    date: match.match_date
  }));
}

export async function toggleMatchParticipation(matchId, userId, joined) {
  if (joined) {
    const { error } = await supabase.from('match_participants').delete().eq('match_id', matchId).eq('user_id', userId);
    if (error) throw error;
  } else {
    const { error } = await supabase.from('match_participants').insert({ match_id: matchId, user_id: userId });
    if (error) throw error;
  }
}
